export default "__VITE_ASSET__4a165b47__"